import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import Chart from "react-apexcharts";
import Config from "../Config";
import { useAuthHandling } from '../useAuthhandling';


function Profusergraph() {
  const [customerdata, setCustomer] = useState([]);
  const [professionals, setProfessionals] = useState([]);

  const { isAuthorized, handleUnauthorized } = useAuthHandling();

  const [options, setOptions] = useState({
    labels: [],
    colors: ["#c717f3", "#6699ff"],

    fill: {
      colors: ["#c717f3", "#6699ff"],
    },
    stroke: {
      colors: ["#c717f3", "#6699ff"],
    },
    title: {
      text: "Day wise joined professionals vs users ",
      align: "left",
      margin: 10,
      offsetX: 0,
      offsetY: 0,
      floating: false,
      style: {
        fontSize: "14px",
        fontWeight: "400",
        fontFamily: undefined,
        color: "#fff",
        marginTop: "12px",
      },
    },
  });
  const [series, setSeries] = useState([
    {
      type: "column",
      name: "Professionals",
      data: [],
    },
    {
      type: "column",
      name: "Users",
      data: [],
    },
  ])

  const getinfo = async (e) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/dashboard/get-professional-vs-users-registrations`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (res.status === 200) {
      const data = await res.json();

      setCustomer(data.data[0].usersData);
      setProfessionals(data.data[0].professionalsData)

      const professionalsData=data.data[0].professionalsData;
      const usersData=data.data[0].usersData;

      const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      
      const currentDate = new Date();
      
      const currentDayOfWeek = currentDate.getDay();
      let labels = [];
      let professionalsCount = [];
      let usersCount = [];
      
      // Find the previous Tuesday
      let previousTuesday = new Date(currentDate);
      // previousTuesday.setDate(currentDate.getDate() - (currentDayOfWeek + 6) % 7 - 6); 
      previousTuesday.setDate(currentDate.getDate()- 6);


      for (let i = 0; i < 7; i++) {
          const date = new Date(previousTuesday);
          // Subtract the days from the previous Tuesday to go back one day at a time
          date.setDate(previousTuesday.getDate() + i);
          const dateString = date.toISOString().split('T')[0]; // Get date string in format 'YYYY-MM-DD'

          // Find the index of the current date in the fetched data
          const index = professionalsData.findIndex(data => data.date === dateString);
          const indexuser = usersData.findIndex(data => data.date === dateString);

          // If data is found for the current date, use it; otherwise, set the count to 0
          const professionalCount = index !== -1 ? professionalsData[index].count : 0;
          const userCount = indexuser !== -1 ? usersData[indexuser].count : 0;
      
          labels.push(weekdays[date.getDay()]); // Add the weekday name to the end of the array
          professionalsCount.push(professionalCount); // Add the professional count to the end of the array
          usersCount.push(userCount); // Add the user count to the end of the array

      }
      
      setOptions(prevOptions => ({
          ...prevOptions,
          labels: labels
      }));
      
      setSeries(prevSeries => ([
          {
              ...prevSeries[0],
              data: professionalsCount
          },
          {
              ...prevSeries[1],
              data: usersCount
          }
      ]));
    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };

 
  useEffect(() => {
    getinfo();
  }, []);
  return (
    <div className="profusergraph">
      <Chart options={options} series={series} width="100%" height="400px" />
    </div>
  );
}

export default Profusergraph;



